const hostname = window.location.hostname;
let host = window.location.host;
let auxiliaryHost = window.location.host
let auxiliaryRoot = "/auxiliary";

let proto = (hostname === "emc2.batstate-u.edu.ph") ? "https" : "http";
let root = "/budget";
let constantEndPoint = "/api/public";

// standard DEV region
if (hostname === "localhost" || hostname === "127.0.0.1") {
  root = "";
  auxiliaryRoot = "";
  constantEndPoint = "";
  host = "localhost";
  auxiliaryHost = "aux.local";
}

// author's development setup
if (hostname === "172.21.131.230") {
  proto = "http";
  root = "";
  constantEndPoint = "";
  host = "172.21.131.230";
}

// for windows development
const port = window.location.port;
if (port === "4201") {
  proto = "http";
  host = "localhost:8080";
  root = "";
  constantEndPoint = "";
}

// SIT region
if (hostname === "127.0.2.1" || hostname === "172.21.130.2") {
  proto = "http";
  host = "172.21.130.2";
}

// budget.c.batstateu.edu.ph
if(hostname === "budget.c.batstateu.edu.ph") {
  root = "";
}

export const env = {
  secure: (proto === "https") ? true : false,
  host: `${proto}://${host}${root}${constantEndPoint}`,

  endpoint: {
    auth_login: "/auth/login",
    auth_logout: "/logout",
    auth_get_session: "/me",
    auth_renew: "/refresh",
    auth_user: "/auth/user/:token/:id",
    auth_user_security: "/auth/user_security",

    fund_get_list: "/fund/get",
    fund_get_pap_type_description: "/fund/get/by_fund",
    // fund_get_category: "/app/get/category",
    // fund_get_budget_fund: "/app/get/budget_fund_category",
    // fund_get_fund_source_reference: "/fund/get/fund_source_reference/{code}",

    fund_source_get_parent: "/fund-source/get_parent/:parent_id",

    account_appropriation_save: "/account/appropriation/save",
    // account_appropriation_get: "/account/appropriation/get",
    account_appropriation_summary: "/account/appropriation/summary",
    account_appropriation_update: "/account/appropriation/update",
    account_appropriation_delete: "/account/appropriation/delete",
    account_appropriation_adjustment: "/account/appropriation/adjustment",
    account_appropriation_update_adjustment: "/account/appropriation/adjustment/update",
    account_appropriation_delete_adjustment: "/account/appropriation/adjustment/delete",
    account_appropriation_fetch_adjustment: "/account/appropriation/adjustment/fetch",

    account_charts_get: "/account/charts/get",
    account_charts_get_available: "/account/charts/get/available",
    account_get_by_fund_collection: "/account/appropriation/get_by_fund_collection",
    account_charts_get_realignment: "/account/charts/get/realignment",

    manage_budget_account_get_list: "/budget/account/get/:major/:sub_major/:ledger/:sub_obj",
    manage_budget_account_save: "/budget/account/save",
    manage_budget_account_delete: "/budget/account/delete/:id",
    manage_budget_account_update: "/budget/account/update",

    allotment_quarter_save: "/allotment/quarter/save",
    allotment_quarter_update: "/allotment/quarter/update",
    allotment_quarter_get_by_account_quarter: "/allotment/quarter/get",
    allotment_delete: "/allotment/quarter/delete/{id}",
    // allocate_funds: '/allocate',

    realignment_save: "/realignment/save",
    realignment_get: "/realignment/get",
    realignment_delete: "/realignment/delete",
    realignment_udpate: "/realignment/update",
    realignment_change_status: "/realignment/change_status",
    realignment_next_series: "/realignment/next_series",
    realignment_details_delete: "/realignment/delete_details",
    realignment_signatories: "/realignment/signatories",
    realignment_signature: "/realignment/signature/:emp_code",
    realignment_for_sign: "/realignment/for_sign/:emp_code",
    realignment_approved_documents: "/realignment/approved_documents/:emp_code",
    realignment_save_attachment: "/realignment/save_attachment",
    realignment_delete_attachment: "/realignment/delete_attachment",
    realignment_get_attachment: "/realignment/get_attachment/:id?token=:token",

    obligation_save: "/ors/save",
    obligation_next_series: "/ors/next_series",
    obligation_get: "/ors/get",
    obligation_summary: "/ors/summary",
    obligation_delete: "/ors/delete/:id",
    obligation_update: "/ors/update",
    obligation_search: "/ors/search",
    obligation_cancel: "/ors/cancel",
    obligation_restore: "/ors/restore/:id",
    obligation_get_total_item_amount: "/ors/get_total_item_amount/:id",
    obligation_delete_status: "/ors/delete_status/:id",
    obligation_delete_status_details: "/ors/delete_status_details/:id",
    obligation_list_summary: "/ors/list",
    obligation_unobligated_allotment: "/ors/unobligated_allotment",

    reports_sabaudb: "/report/sabaudb",
    reports_sabaudb_account_summary: "/report/sabaudb/account_summary",
    reports_far2: "/report/far2",
    reports_far2a: "/report/far2a",
    reports_consolidation_sabaudb_pre: "/report/consolidation/sabaudb_pre",
    reports_sabaudb_data: "/report/sabaudb_data",
    reports_registry: "/report/registry",
    reports_registry_summary: "/report/registry-summary",

    dashboard_bur: "/dashboard/bur",
    dashboard_overall_operating_budget: "/dashboard/overall_operating_budget",

    register_save: "/register/account",

    mfo_pap_search: "/mfo_pap/search",

    payee_get: "/payee/get",
    payee_save: "/payee/save",
    payee_get_by_id: "/payee/get/:id",

    // fund_get_sysref: "/fund/get/sysref",

    // function_available_get: "/function/available/get",

    hr_designation: "/designation/lists",
    hr_designation_employee: "/designation/employee/",
    hr_employee: "/employee/get/:id",
    hr_search_employee: "/employee/search",

    users_delete: "/users/delete",
    users_save: "/users/save",
    users_lists: "/users/lists",
    users_search: "/users/search",
    users_update: "/users/update/:id",
    users_jwt: "/users/jwt",

    user_types_lists: "/usertypes/lists",
    user_types_update: "/usertypes/update",
    user_types_add: "/usertypes/add",
    user_types_delete: "/usertypes/delete",

    // system_get_list: "/system/get",
    // system_save: "/system/save",
    system_update: "/system/update",
    // system_delete: "/system/delete",
    // system_get_by_id: "/system/get"

    caa_save: "/caa/save",
    caa_fetch: "/caa/fetch",
    caa_delete: "/caa/delete",
    caa_find: "/caa/find/:id",
    caa_update: "/caa/update",
    caa_lists: "/caa/lists",
  },

  campuses: [
    {
      value: 0,
      text: "CENTRAL ADMINISTRATION",
      address: "Batangas City",
      details: {
        name: "Central Administration",
        addr: "Rizal Avenue Ext., Batangas City, Batangas, Philippines 4200",
        contact: "(+63 43) 779-8400; 406-8600 local 1987 or 1168",
        email: "budget.central@g.batstate-u.edu.ph"
      },
      // mds_bur1_target: 90, mds_bur2_target: 60, stf_bur1_target: 40, stf_bur2_target: 60 // 2024
      mds_bur1_target: 90, mds_bur2_target: 60, stf_bur1_target: 70, stf_bur2_target: 70
    }, {
      value: 1,
      text: "Pablo Borbon",
      address: "Batangas City",
      details: {
        name: "Pablo Borbon Campus",
        addr: "Rizal Avenue Ext., Batangas City, Batangas, Philippines 4200",
        contact: "(+63 43) 980-0385; 980-0388; 980-0392 to 94 local 1214",
        email: "budget.pb@g.batstate-u.edu.ph"
      },
      mds_bur1_target: 90, mds_bur2_target: 85, stf_bur1_target: 50, stf_bur2_target: 50
    }, {
      value: 2,
      text: "Nasugbu",
      address: "Nasugbu, Batangas",
      details: {
        name: "Nasugbu Campus",
        addr: "R. Martinez St., Brgy. Bucana, Nasugbu, Batangas, Philippines 4231",
        contact: "+63 43 416-0350 local 415",
        email: "budget.nasugbu@g.batstate-u.edu.ph"
      },
      mds_bur1_target: 90, mds_bur2_target: 85, stf_bur1_target: 70, stf_bur2_target: 70
    }, {
      value: 3,
      text: "Malvar",
      address: "Malvar, Batangas",
      details: {
        name: "JPLPC Malvar Campus",
        addr: "G. Leviste St., Poblacion, Malvar, Batnagas, Philippines 4233",
        contact: "(+63 43) 778-2170 / (+63 43) 778-6633 local 9307; (+63 43) 406-0830",
        email: "budget.malvar@g.batstate-u.edu.ph"
      },
      mds_bur1_target: 90, mds_bur2_target: 80, stf_bur1_target: 70, stf_bur2_target: 70
    }, {
      value: 4,
      text: "Alangilan",
      address: "Alangilan, Batangas City",
      details: {
        name: "Alangilan Campus",
        addr: "Golden Country Homes, Alangilan, Batangas City, Philippines 4200",
        contact: "(043) 425-0139 425-0143 loc. 2814",
        email: "budget.alangilan@g.batstate-u.edu.ph"
      },
      mds_bur1_target: 90, mds_bur2_target: 85, stf_bur1_target: 50, stf_bur2_target: 50
    }, {
      value: 5,
      text: "Lipa",
      address: "Lipa City",
      details: {
        name: "Lipa Campus",
        addr: "A. Tanco Drive Marawoy, Lipa City, Batangas Philippines 4217",
        contact: "(043) 980-0387 local 3120; (+63) 43774-2526",
        email: "budget.lipa@g.batstate-u.edu.ph"
      },
      mds_bur1_target: 80, mds_bur2_target: 80, stf_bur1_target: 80, stf_bur2_target: 80
    }
  ],

  fundsource: {
    MDS: {
      '': "Agency Specific Budget",
      '-AA': "Automatic Appropriation",
      '-SPF': "Special Purpose Fund",
      '-CB': "Continuing"
    },
    STF: {
      '': "Program of Receipts & Expenditures (PRE)",
      '-SB-CB': "Supplemental Budget",
      '-SB': "Supplemental Budget (Savings)",
      '-CB': "Supplemental Budget (Continuing)"
    },
    IGP: {
      '': "IGP"
    }
  },

  fund_source_ors: {
    MDS: {
      '': "Agency Specific Budget",
      '-AA': "Automatic Appropriation",
      '-SPF': "Special Purpose Fund",
      '-CB': "Continuing"
    },
    STF: {
      '': "PRE FY {year}",
      '-SB-CB': "Supplemental Budget FY {year}",
      '-SB': "Savings FY {year}",
      '-CB': "Continuing FY {year}"
    },
    IGP: {
      '': "IGP"
    }
  },

  responsibility_center: {
    164: "STF Fund",
    101: "MDS Fund",
    RTF: "RTF Fund",
    163: "IGP Fund"
  },

  realignment_fund_name: {
    164: "Special Trust Fund",
    101: "MDS Fund",
    RTF: "RTF Fund",
    163: "IGP Fund"
  },

  fund_source_value: {
    // MDS: "101",
    // STF: "164",
    // IGP: "163",
    // RTF: "RTF"
    '101': "MDS",
    '164': "STF",
    '164-SB': "STF",
    '164-CB': "STF",
    '163': "IGP",
    'RTF': "RTF"
  },

  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],

  short_months: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],

  president: {
    name: "Dr. RONQUILLO A. TIRSO",
    emp_id: "00271",
    position: "University President"
  },

  budget_oic: {
    '2023': [
      { id: 0, name: "CENTRAL", head: { name: "ROMEO L. RAMOS", position: "Director for Finance", emp_id: "00699" } },
      { id: 1, name: "Pablo Borbon", head: { name: "GERRIMIE C. DINGLASAN", position: "Head Budget Office", emp_id: "01437" } },
      { id: 2, name: "Nasugbu", head: { name: "ELEONOR T. LAÑA", position: "Head Budget Office", emp_id: "04321" } },
      { id: 3, name: "Malvar", head: { name: "JOVITO P. PERMANTE", position: "Head Budget Office", emp_id: "00252" } },
      { id: 4, name: "Alangilan", head: { name: "DR. MAYLEN G. EROA", position: "Head Budget Office", emp_id: "00146" } },
      { id: 5, name: "Lipa", head: { name: "MARIEL S. FAJILAN", position: "Head Budget Office", emp_id: "56870" } },
    ],
    '2024': [
      { id: 0, name: "CENTRAL", head: { name: "ROMEO L. RAMOS", position: "Director for Finance", emp_id: "00699" } },
      { id: 1, name: "Pablo Borbon", head: { name: "DR. JENNIFER M. PEREZ", position: "Head Budget Office", emp_id: "00191" } },
      { id: 2, name: "Nasugbu", head: { name: "ELEONOR T. LAÑA", position: "Head Budget Office", emp_id: "04321" } },
      { id: 3, name: "Malvar", head: { name: "JOVITO P. PERMANTE", position: "Head Budget Office", emp_id: "00252" } },
      { id: 4, name: "Alangilan", head: { name: "DR. MAYLEN G. EROA", position: "Head Budget Office", emp_id: "00146" } },
      { id: 5, name: "Lipa", head: { name: "ROSELLE B. GODOY", position: "Head Budget Office", emp_id: "02110" } },
    ],
    '2025': [
      { id: 0, name: "CENTRAL", head: { name: "Mrs. CZARINA YVETTE A. PINEDA", position: "Assistant Director for Budget", emp_id: "01831" } },
      { id: 1, name: "Pablo Borbon", head: { name: "DR. JENNIFER M. PEREZ", position: "Head Budget Office", emp_id: "00191" } },
      { id: 2, name: "Nasugbu", head: { name: "Ms. ELEONOR T. LAÑA", position: "Head Budget Office", emp_id: "04321" } },
      { id: 3, name: "Malvar", head: { name: "Ms. PRINCESS SUZANE T. REAÑO", position: "Head Budget Office", emp_id: "03343" } },
      { id: 4, name: "Alangilan", head: { name: "DR. MAYLEN G. EROA", position: "Head Budget Office", emp_id: "00146" } },
      { id: 5, name: "Lipa", head: { name: "Ms. MARIEL S. FAJILAN", position: "Head Budget Office", emp_id: "56870" } },
    ],
    '2026': [
      { id: 0, name: "CENTRAL", head: { name: "Mrs. CZARINA YVETTE A. PINEDA", position: "Assistant Director for Budget", emp_id: "01831" } },
      { id: 1, name: "Pablo Borbon", head: { name: "DR. JENNIFER M. PEREZ", position: "Head Budget Office", emp_id: "00191" } },
      { id: 2, name: "Nasugbu", head: { name: "Ms. ELEONOR T. LAÑA", position: "Head Budget Office", emp_id: "04321" } },
      { id: 3, name: "Malvar", head: { name: "Ms. PRINCESS SUZANE T. REAÑO", position: "Head Budget Office", emp_id: "03343" } },
      { id: 4, name: "Alangilan", head: { name: "DR. MAYLEN G. EROA", position: "Head Budget Office", emp_id: "00146" } },
      { id: 5, name: "Lipa", head: { name: "Ms. MARIEL S. FAJILAN", position: "Head Budget Office", emp_id: "56870" } },
    ]
  },

  realignment_status: {
    0: "Pending",
    1: "Recommended",
    2: "Approved",
    3: "Recommended",
    4: "For Review"
  },

  roman_numbers: {
    '00': "",
    '01': "I",
    '02': "II",
    '03': "III",
    '04': "IV",
    '05': "V"
  },

  user_types: {
    1: "Admin",
    2: "ORS Staff",
    8: "Fund Manager",
    9: "Manager"
  },

  realignment_legal_basis: {
    2023: "BOR Res. No. 132, S. 2022",
    2024: "BOR Res. No. 164, S. 2023",
    2025: "BOR Res. No. 93,s. 2024",
    // 2026: "BOR Res. No. 93,s. 2024"
    2026: "BOR Res. No. 6, s. 2026"
  },

  realignment_apsa_programs: [
    { source: "100000000", value: "100000100001000", text: "General Management and Supervision" },
    { source: "200000000", value: "200000100001000", text: "Auxiliary Services" },
    { source: "300000000", value: "310100100002000", text: "Provision of Higher Education Services" },
    { source: "300000000", value: "320100100001000", text: "Provision of Advanced Education Services" },
    { source: "300000000", value: "320200100001000", text: "Conduct of Research Services" },
    { source: "300000000", value: "330100100001000", text: "Provision of Extension Services" }
  ],

  allotment_class: {
    '01': "Personnel Services",
    '02': "Maintenance and Other Operating Expenses",
    '03': "Financial Expenses",
    '04': "Direct Costs",
    '05': "Non-Cash Expenses",
    '06': "Capital Outlays",
    '60': "Mandatory Reserve Fund",
    '70': "Reserve Fund",
    '98': "Research Projects",
    '99': "Extension, PAPs"
  },

  igp: {
    auxiliary_url: `${proto}://${auxiliaryHost}${auxiliaryRoot}`,
  },

  stf_fund: [
    {
      code: '164-SB',
      name: 'STF - SB (Savings)'
    },
    {
      code: '164-CB',
      name: 'STF - SB (Continuing)'
    }
  ],

  // roles: [
  //   { value: 1, text: "Admin" }j
  //   { value: 2, text: "ORS Staff" },
  //   { value: 8, text: "Fund Manager" },
  //   { value: 9, text: "Manager" },
  //   { value: 10, text: "Signatory" },
  //   { value: 11, text: "Authenticated User" }
  // ],

  token_hours_expiration: 4,
  token_renew_expire_at: 1,

  version: "v3.7.26"

} as any;

